var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"photo-with-bottom-pro-badge p-relative"},[_c('img',{staticClass:"photo",attrs:{"src":_vm.src}}),_c('span',{staticClass:"pro-badge p-absolute",domProps:{"innerHTML":_vm._s(_vm.$translate('PRO'))}})])}
var staticRenderFns = []

export { render, staticRenderFns }